import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      width: '14em',
      '@media (max-height: 800px), (max-width: 1400px)': {
        width: '13em',
      },
      height: '35em',
      // border: '2px solid red',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start',
      marginLeft: '10px',
    },
  }),
  { index: 1 },
)

export { useStyles }
